/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountRollupListResponse,
  ArchetypeRollupListResponse,
  DiagnosticSummaryResponse
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * @summary Get Summary
 */
export const getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DiagnosticSummaryResponse>(
      {url: `/v1/opportunity-diagnostic-intelligence/summary`, method: 'GET', signal
    },
      );
    }
  



export const getGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryKey = () => {
    return [
    `/v1/opportunity-diagnostic-intelligence/summary`
    ] as const;
    }

    
export const getGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryOptions = <TData = Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>> = ({ signal }) => getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>>
export type GetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryError = unknown


export function useGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGet<TData = Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGet<TData = Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGet<TData = Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Summary
 */

export function useGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGet<TData = Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSummaryV1OpportunityDiagnosticIntelligenceSummaryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSummaryV1OpportunityDiagnosticIntelligenceSummaryGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get Account Rollups
 */
export const getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccountRollupListResponse>(
      {url: `/v1/opportunity-diagnostic-intelligence/accounts`, method: 'GET', signal
    },
      );
    }
  



export const getGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryKey = () => {
    return [
    `/v1/opportunity-diagnostic-intelligence/accounts`
    ] as const;
    }

    
export const getGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryOptions = <TData = Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>> = ({ signal }) => getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>>
export type GetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryError = unknown


export function useGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet<TData = Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet<TData = Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet<TData = Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Account Rollups
 */

export function useGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet<TData = Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAccountRollupsV1OpportunityDiagnosticIntelligenceAccountsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get Archetypes
 */
export const getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ArchetypeRollupListResponse>(
      {url: `/v1/opportunity-diagnostic-intelligence/archetypes`, method: 'GET', signal
    },
      );
    }
  



export const getGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryKey = () => {
    return [
    `/v1/opportunity-diagnostic-intelligence/archetypes`
    ] as const;
    }

    
export const getGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryOptions = <TData = Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>> = ({ signal }) => getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>>
export type GetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryError = unknown


export function useGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet<TData = Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>,
          TError,
          Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet<TData = Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>,
          TError,
          Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet<TData = Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Archetypes
 */

export function useGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet<TData = Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetArchetypesV1OpportunityDiagnosticIntelligenceArchetypesGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



